import { lazy } from 'react';

// Types
import { PaymentOptionProps as LazyComponentProps } from './PaymentOption.types';

// Components
import withSuspense, { lazyRetry } from '../../suspense';

const LazyComponent = lazy(() => lazyRetry(() => import(/* webpackChunkName: "paymentOption" */ './PaymentOption')));

const LazyComponentWithSuspense = withSuspense<LazyComponentProps>(LazyComponent, 'PaymentOption');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as PaymentOption };
